import loadIcons, { loadDefs } from './skin/icons-loader';
import settingsMenu from './skin/settings-menu';

/**
 * Load SVP Skin
 *
 * @param svpPlayer
 * @param options
 */
export default (svpPlayer) => {
    loadDefs(svpPlayer);

    settingsMenu(svpPlayer);
    loadIcons(svpPlayer);
};